<ng-container *ngIf="layoutInstructions | getNInternalGridCrosses: nCardsOnPage as nInternalCrosses">
  <ng-template ngFor [ngForOf]="this | method: 'repeat' : nInternalCrosses" let-i="index">
    <app-internal-grid-cut-line-cross
      [layoutInstructions]="layoutInstructions"
      [style.top.px]="layoutInstructions | getInternalGridCutLineCrossTopOffset: nCardsOnPage : i"
      [style.left.px]="layoutInstructions | getInternalGridCutLineCrossLeftOffset: nCardsOnPage : i">
    </app-internal-grid-cut-line-cross>
  </ng-template>
</ng-container>
